<template>
    <v-container>
        <h1 class="titulo mb-3">CONFIGURAÇÕES DE PENDÊNCIAS DA ANÁLISE DE CRÉDITO</h1>
        <v-card class="card">
            <v-card-text>
                <m-form ref="form">
                    <v-row>
                        <v-col cols="6" md="4">
                            <m-text-field label="Código da Pendência" class="required"
                                          v-input-filter="[$filters.numeric]"
                                          outlined :rules="[$rules.required]" placeholder="Digite o código da pendência"
                                          item-text="label" item-value="value" v-model="configuracao.codigo_pendencia">
                            </m-text-field>
                        </v-col>
                        <v-col cols="6" md="8">
                            <m-text-field label="Motivo da Pendência" class="required"
                                          outlined :rules="[$rules.required]" placeholder="Digite o motivo da pendência"
                                          item-text="label" item-value="value" v-model="configuracao.motivo">
                            </m-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-6 d-flex">
                        <v-col cols="8">
                            <HintMessage style="max-width: 500px;" class="mb-5" title="DICA PARA CONFIGURAÇÃO"
                                         icon="mdi-lightbulb-on-outline" icon-color="secondary"
                                         description='<p>A opção <strong>"Código da Pendência"</strong> é o <strong>código de retorno do motor de crédito</strong>.</p> <p>O <strong>"Motivo da Pendência"</strong> será <strong>exibido ao parceiro</strong> em caso de Pendências.</p>'
                                         :description-html="true"
                                         :center-icon="false" />
                        </v-col>
                        <v-col cols="4" class="d-flex justify-end">
                            <v-btn class="transition" color="primary" rounded @click="inserir">
                                Salvar
                            </v-btn>
                        </v-col>
                    </v-row>
                </m-form>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition ml-1" color="primary" rounded @click="toggleFiltro">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn class="transition mr-1" color="primary" rounded @click="exportarExcel">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        Salvar Relatório
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" v-show="filter_open" class="mt-4 ml-2">
                        <v-row>
                            <v-col cols="6">
                                <m-text-field label="Código da Pendência"
                                              v-input-filter="[$filters.numeric]"
                                              outlined placeholder="Digite o código da pendência"
                                              item-text="label" item-value="value" v-model="filters.codigo_pendencia">
                                </m-text-field>
                            </v-col>
                            <v-col cols="6">
                                <m-text-field label="Motivo da Pendência"
                                              outlined placeholder="Digite o motivo da pendência"
                                              item-text="label" item-value="value" v-model="filters.motivo">
                                </m-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="d-flex justify-start">
                                <v-btn color="secondary" @click="limpar">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="d-flex justify-end">
                                <v-btn color="primary" @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <DataTable ref="datatable" url="/painel/config_pendencia/listar" class="pt-2 data-table-overlow"
                           :headers="headers" :params="params" :filter="dtFilters">
                    <template v-slot:items="{item}">
                        <td class="text-center">
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes" v-bind="attrs" v-on="on" style="margin: 10px 0px;
                                        padding: 5px;
                                        min-width: 48px;">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">
                                            O que deseja fazer?
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <v-list-item-title>Editar</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirmExcluir(item.id)">
                                        <v-list-item-title>Excluir</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td class="text-center">{{ item.codigo_pendencia || '-' }}</td>
                        <td class="text-center">{{ item.motivo || '-' }}</td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { AlertTypes } from '@/plugins/alerts_types'
  import { alert, notification } from '@/plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'ConfigCreditAnalysisPendencias',
    data: () => ({
      filter_open: false,
      pagination: {
        sortBy: [], descending: []
      },
      dtFilters: {},
      configuracao: {
        codigo_pendencia: null,
        motivo: ''
      },
      filters: {
        codigo_pendencia: null,
        motivo: ''
      },
      headers: [
        { text: 'Ações', value: '', align: 'center', sortable: false },
        { text: 'Código da Pendência', value: 'codigo_pendencia', align: 'center', sortable: true },
        { text: 'Motivo da Pendência', value: 'motivo', align: 'center', sortable: true }
      ]

    }),
    computed: {
      params () {
        return {
          pagination: this.pagination
        }
      }
    },
    methods: {
      async inserir () {
        if (!this.$refs.form.validate()) {
          return
        }

        this.configuracao.codigo_pendencia = parseInt(this.configuracao.codigo_pendencia, 10)

        const payload = {
          codigo_pendencia: this.configuracao.codigo_pendencia,
          motivo: this.configuracao.motivo
        }

        if (this.configuracao.id) {
          await this.salvarPendencia(this.$http, payload, this.configuracao.id)
        } else {
          await this.salvarPendencia(this.$http, payload)
        }
      },
      async salvarPendencia (http, payload, id = null) {
        try {
          let response
          if (id) {
            response = await http.put(`/painel/config_pendencia/editar/${id}`, payload)
          } else {
            response = await http.post('/painel/config_pendencia/salvar', payload)
          }

          if (response.data.success) {
            notification(AlertTypes.SUCCESS, response.data.message)
          }

          this.resetForm()
          this.$refs.datatable.reload()
        } catch (error) {
          let errorMessage = error.response?.data?.error || error.message

          notification(AlertTypes.ERROR, errorMessage)
        }
      },
      editar (item) {
        this.configuracao = {
          id: item.id,
          codigo_pendencia: item.codigo_pendencia,
          motivo: item.motivo
        }

        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      async confirmExcluir (id) {
        alert({
          text: `Tem certeza que deseja excluir a configuração de pendência?`,
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              try {
                const response = await this.$http.delete(`/painel/config_pendencia/excluir/${id}`)
                notification(AlertTypes.SUCCESS, response.data.message)
                this.$refs.datatable.reload()
              } catch (error) {
                let errorMessage = error.response?.data?.error || error.message
                notification(AlertTypes.ERROR, errorMessage)
              }
            }
          }
        })
      },
      exportarExcel () {
        const filtros = { ...this.filters }

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/config_pendencia/exportar?${encoded_params}`)
      },
      resetForm () {
        this.configuracao = {
          codigo_pendencia: null,
          motivo: ''
        }
        this.$refs.form.resetValidation()
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      filtrar () {
        if (this.$refs.filter.validate()) {
          const filtros = { ...this.filters }
          this.dtFilters = filtros
        }
      },
      limpar () {
        this.filters = {
          codigo_pendencia: null,
          motivo: ''
        }
        this.filtrar()
        this.filter_open = false
      }
    }
  }
</script>
